import { PhotographyTitlesPropsType } from '@/common/components/camera/queries/photographingTitles/photographyTitlesQuery.type';
import photographyTitlesQueryFunction from '@/common/components/camera/queries/photographingTitles/photographyTitlesQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const photographyTitlesQueryOptions = ({
  params,
  enabled,
  onSuccess,
}: PhotographyTitlesPropsType) => {
  return queryOptions({
    enabled: enabled,
    queryKey: ['photographyTitles', params],
    queryFn: () => photographyTitlesQueryFunction({ params }),
    meta: {
      onSuccess,
    },
  });
};
